<script>
/* eslint-disable */
/**
 * 진리의 stackoverflow..!
 * https://stackoverflow.com/questions/71168747/how-to-make-vuetify-dialog-draggable
 */

/* add class .vss-movable to <v-card-title> to make a dialog movable */

(function () {
  const d = {};
  const isMovable = (targ) => targ.classList?.contains('vss-movable');

  document.addEventListener('mousedown', (event) => {
    const closestDialog = event.target.closest('.v-overlay__content');
    const title = closestDialog?.querySelector('.v-card-title');
    if (
      event.button === 0
      && closestDialog != null
      && (isMovable(event.target))
      || isMovable(event.target.parentNode)
    ) {
      d.el = closestDialog; // movable element
      d.handle = title; // enable dlg to be moved down beyond bottom
      d.mouseStartX = event.clientX;
      d.mouseStartY = event.clientY;
      d.elStartX = d.el.getBoundingClientRect().left;
      d.elStartY = d.el.getBoundingClientRect().top;
      d.el.style.position = 'fixed';
      d.el.style.margin = 0;
      d.oldTransition = d.el.style.transition;
      d.el.style.transition = 'none';
    }
  });

  document.addEventListener('mousemove', (event) => {
    if (d.el === undefined) { return; }
    // d.el.style.left = `${Math.min(
    //   Math.max(d.elStartX + event.clientX - d.mouseStartX, 0),
    //   window.innerWidth - d.el.getBoundingClientRect().width,
    // ) }px`;
    // d.el.style.top = `${Math.min(
    //   Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
    //   window.innerHeight - d.handle.getBoundingClientRect().height,
    // ) }px`;

    // 위 내용은 다이얼로그 너비 감안한 부분, 아래 패턴은 다이얼로그 너비 상관 x
    d.el.style.left = `${Math.max(d.elStartX + event.clientX - d.mouseStartX, 0)}px`;
    d.el.style.top = `${Math.max(d.elStartY + event.clientY - d.mouseStartY, 0)}px`;
  });

  document.addEventListener('mouseup', () => {
    if (d.el === undefined) { return; }
    d.el.style.transition = d.oldTransition;
    d.el = undefined;
  });
}());
</script>

<style>
.v-overlay.v-dialog .vss-movable {
  cursor: grab;
}

.v-overlay.v-dialog .vss-movable:hover {
  background-color: #eee;
}

.v-overlay.v-dialog .vss-movable:active {
  cursor: grabbing;
}
</style>
